export const REQUIRED_MSG = 'This field is required'
export const EXCHANGE_RATE_TOOLTIP =
  "This exchange rate has been auto-populated using OANDA's rates based on time of application submission."

export const OMP_GRANT_CAP_LIMIT = 20000
export const OBD_GRANT_CAP_LIMIT = 50000
export const OMS_GRANT_CAP_LIMIT = 30000
